import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, setLogLevel } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration (from Firebase console)
const firebaseConfig = {
  apiKey: 'AIzaSyCWpyIIGKpadxqXQDQ8leTWMiEVnJ1E1E4',
  authDomain: 'moro-a4c90.firebaseapp.com',
  projectId: 'moro-a4c90',
  storageBucket: 'moro-a4c90.firebasestorage.app',
  messagingSenderId: '412235890203',
  appId: '1:412235890203:web:fa8117f5cc1102f14c42be',
  measurementId: 'G-HZBKXVQ3KG',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app, '(default)');


// Enable Firestore SDK debug logs for deep troubleshooting
setLogLevel('debug');

export default app;